export default[
    {
        path: '/WbhQt4MKvu2o9erkEbKC',
        children: [
        {
        path: '',
        name: 'years-list',
        meta: {
            title: 'Academic Years',
            authRequired: true,
            acc: ['v50'],
        },
        component: () => import('../views/year/index'),
    },
    {
        path: 'yren',
        name: 'year-new',
        meta: {
            title: 'New Academic Years',
            authRequired: true,
            acc: ['v50'],
        },
        component: () => import('../views/year/create'),
    },
    {
        path: 'yrn',
        name: 'view-year',
        meta: {
            title: 'View Academic Year',
            authRequired: true,
            acc: ['v50'],
        },
        component: () => import('../views/year/view'),
    },
    {
        path: 'y',
        name: 'edit-year',
        meta: {
            title: 'Edit Academic Year',
            authRequired: true,
            acc: ['v50'],
        },
        component: () => import('../views/year/edit'),
    },
        ]
    }
]